module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-full-calendar"
  }, [_c('tc-header', {
    attrs: {
      "current-date": _vm.currentDate,
      "title-format": _vm.titleFormat,
      "first-day": _vm.firstDay,
      "month-names": _vm.localeMonthNames,
      "short-month-names": _vm.localeShortMonthNames
    },
    on: {
      "change": _vm.emitChangeMonth
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-left"
    },
    slot: "header-left"
  }, [_vm._t("tc-header-left")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._t("tc-header-right")], 2)]), _vm._v(" "), _c('tc-body', {
    attrs: {
      "current-date": _vm.currentDate,
      "events": _vm.events,
      "month-names": _vm.localeMonthNames,
      "week-names": _vm.localeWeekNames,
      "first-day": _vm.firstDay
    },
    on: {
      "eventclick": _vm.emitEventClick,
      "dayclick": _vm.emitDayClick,
      "moreclick": _vm.emitMoreClick
    }
  }, [_c('div', {
    attrs: {
      "slot": "body-card"
    },
    slot: "body-card"
  }, [_vm._t("tc-body-card")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0630dcac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar.vue
// module id = 338
// module chunks = 0